import fetchModels from "../../mixin/store/api/fetchModels";
import fetchModel from "@/mixin/store/api/fetchModel";
import axios from "@/plugins/axios";
import changeOrPushModel from "../../mixin/store/api/changeOrPushModel";

export default {
    actions: {
        fetchWarehouses(context, page) {
            return fetchModels(context, 'warehouses', page, 'updateWarehouses');
        },
        fetchWarehousesSearch(context, page = null) {
            if (context.state.warehouses.isNeedFetch) {
                return fetchModels(context, 'warehouses', page, 'updateWarehouses');
            }
        },
        fetchWarehouse(context, id) {
            return fetchModel(context, 'warehouses/' + id + '/products', null, 'updateWarehouse');
        },
        fetchOneWarehouse(context, id) {
            return fetchModel(context, 'warehouses/' + id, null, 'updateWarehouse');
        },
        fetchWarehouseStatistics(context) {
            return fetchModel(context, 'warehouses/total_amount', null, 'updateWarehouseStatistic')
        },
        pushWarehouse(context, data) {
            return changeOrPushModel(context, 'warehouses', data)
        },
        deleteWarehouse(context, {id, newWarehouse = null}) {
            let url = 'warehouses/delete/' + id

            if (newWarehouse) {
                url += '?rebase=' + newWarehouse
            }

            return new Promise((resolve, reject) => {
                axios.get(url)
                    .then(() => {
                        resolve()
                    })
                    .catch((error) => {
                        if (error === 'connectionRefused') {
                            reject(error)
                        }

                        reject(error.response.data['hydra:description'])
                    })
            })
        },
        searchWarehouse(context, data) {
            let url = (data.name !== '') ? ('&name=' + data.name) : '';
            return axios.get('warehouses?page=' + data.page + url)
                .then((response) => {
                    console.log(response)
                    let data = {
                        models: response.data['hydra:member'],
                        totalItems: response.data['hydra:totalItems']
                    }
                    context.commit('updateWarehouses', data)
                })
                .catch((err) => {
                    console.log(err)

                })
        },

    },
    mutations: {
        updateWarehouses(state, data) {
            state.warehouses = data
            state.warehouses.isNeedFetch = false
        },
        updateWarehouse(state, data) {
            state.warehouse = data
        },
        updateWarehouseStatistic(state, data) {
            state.warehouseStatistic.sellingPriceTotalAmount = data['hydra:member'][0]
            state.warehouseStatistic.purchasePriceTotalAmount = data['hydra:member'][1]
            state.warehouseStatistic.productsTotalCount = data['hydra:member'][2]
            state.warehouseStatistic.currency = data['hydra:member'][3]
        },
    },
    state: {
        warehouses: {
            models: [],
            totalItems: 0,
            isNeedFetch: true
        },
        warehouse: {
            id: null,
            name: null,
            company: null,
            productsInWarehouses: [
                {
                    id: null,
                    product: {
                        id: null,
                        name: null
                    }
                }
            ],
        },
        warehouseStatistic: {
            sellingPriceTotalAmount: null,
            purchasePriceTotalAmount: null,
            productsTotalCount: null,
            currency: {}
        },
    },
    getters: {
        getWarehouses(state) {
            return state.warehouses.models
        },
        getWarehouse(state) {
            return state.warehouse
        },
        getWarehousesTotalCount(state) {
            return state.warehouses.totalItems
        },
        getWarehouseStatistic(state) {
            return state.warehouseStatistic
        },
    },
}
